import { Button } from "@mui/material";
import {useRouter} from "next/router";
import {useTranslation,nextPreload} from "@fanfanlo"
import { useEffect } from "react";
export function AddExternalMarketButton(){
    const router = useRouter()
    const {t} = useTranslation('homepage/components/markets/content');
    
      useEffect(() => {
        nextPreload(router, '/add-market');
      }, []);
    function onClick(){
        router.push("/add-market")
    }
    return (
        <Button
          onClick={onClick}
          data-testid="AddExternalMarketButton__addButton__01JFQX8K9W"
          data-test-comment="添加外部市场按钮，点击后导航到添加市场页面"
        >
            {t("AddExternalMarketButton.name")}
        </Button>
    )
}